// endpoint defined in auth_service (/auth)
export const GOOGLE_SSO_START_PATH = '/api/auth/sso/google/start';
export const LOGOUT_PATH = '/api/auth/logout';
export const STAFF_GOOGLE_WORKSPACE_DOMAIN = 'cambridgespark.com';
export const SSO_FAILED_QUERY_VALUE = 'sso_failed';
